import React, { Component } from 'react';
import Header from './components/header/header';
import BootGraphic from './components/boot-graphic/bootgraphic';
import BootSelector from './components/bootselector';
import Footer from './components/footer/footer';

import { Data } from './data';

class App extends Component {
    render() {
        return (
            <div className="App">
                <Header />
                <BootGraphic />
                <BootSelector data={Data} />
                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js